import React from "react";
import {connect} from "react-redux";
import {setActiveLang} from "../redux/actions";

class LanguagePicker extends React.Component {
    constructor(props) {
        super ( props );
        this.state = {
            selectValue : this.props.lang,
            rerender: false,
            jmbgContractor : ""
        };
        this.handleChange = this.handleChange.bind(this)
    }


    handleChange(e) {
        this.setState ( { selectValue : e.target.value }
        );
    }
    render() {

        return (
            <div>
                <select
                    value={!!this.state.selectValue?this.state.selectValue:this.props.lang}
                    onClick={(e)=> {
                        this.props.setActiveLang (
                            { lang : this.state.selectValue }
                        );
                        !this.state.rerender?this.setState({rerender : true}):this.setState({rerender : false});
                    }}
                    onChange={(e)=>{
                        this.props.setActiveLang(
                            { lang : this.state.selectValue }

                        );
                      //  !this.state.rerender?this.setState({rerender : true}):this.setState({rerender : false});
                        this.handleChange(e);

                    }}
                >
                    <option value="sr">Crnogorski</option>
                    <option value="en">English</option>
                </select>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return ({
        lang : state.lang
    });
};
const mapDispatchToProps = (dispatch) => {
    return ({
        setActiveLang : (params) => {
            dispatch ( setActiveLang ( params ) );
        }
    })
};
export const Lang = connect ( mapStateToProps, mapDispatchToProps ) ( LanguagePicker );